<template>
  <v-button
    :light="!isFeed"
    :round="!isTextStyle"
    :rounded="isTextStyle"
    :raised="isTextStyle"
    :primary="isTextStyle"
    :class="
      `${isOn ? '--on' : ''}
       ${isFeed ? '--is-feed' : ''}
      notification-button v-toolbar__button flex-grow-0 ml-1 m-0
      `
    "
    @click="toggle"
  >
    <template v-if="isToggling">
      <v-loader thin />
    </template>
    <template v-else-if="isOn">
      <v-icon icon="notifications_active" size="1rem" />
    </template>
    <template v-else>
      <template v-if="text">
        {{ text }}
      </template>
      <v-icon v-else icon="notifications_off" size="1rem" />
    </template>
  </v-button>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

import EventBus, { EVENTS } from "@/lib/event-bus"

export default {
  props: {
    messageThreadId: { type: [String, Number], required: true },
    isFeed: { type: Boolean, default: false },
    text: { type: String, default: null }
  },

  data() {
    return {
      isToggling: false
    }
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated", "currentUser"]),
    ...mapGetters("messages", ["getParticipant"]),

    isOn() {
      return this.getParticipant(this.messageThreadId)?.notifications_enabled
    },

    isTextStyle() {
      return this.text && !this.isOn
    }
  },

  methods: {
    ...mapActions("messages", ["toggleNotification"]),

    toggle() {
      if (!this.isAuthenticated) {
        return this.$router.push("#auth")
      }

      this.isToggling = true

      this.toggleNotification({
        messageThreadId: this.messageThreadId,
        active: !this.isOn
      })
        .then(active => {
          if (active) {
            EventBus.$emit(EVENTS.PROMPT_PUSH_PERMISSION, {
              ignoreDismissed: true
            })
            this.$emit("enabled")
          }

          this.$notify(
            active ? "Enabled notifications" : "Disabled notifications"
          )
        })
        .finally(() => {
          this.isToggling = false
        })
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.notification-button {
  height: $notification-button--size;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &.--on {
    width: $notification-button--size;
    box-shadow: $box-shadow--medium !important;
    opacity: 1;
    padding: 0;

    &.--is-feed {
      background: $color-fixed--white;
    }
  }

  &:not(.--is-feed) {
    width: $notification-button--size;
  }

  .v-loader {
    width: $size--4;
    height: $size--4;
  }

  &.--is-feed {
    margin-bottom: $size--2;
  }
}

.v-toolbar.--transparent .v-toolbar__button.--on {
  background: $color-ui--white;
  color: $color-ui--grey-70;
}

.v-toolbar:not(.--transparent) .notification-button {
  opacity: 0.5;

  &.--on {
    opacity: 1;
  }
}

.v-toolbar.--dark .notification-button {
  background: transparent;
  color: $color-ui--white !important;
  opacity: 0.5;

  &.--on {
    opacity: 1;
  }
}
</style>
